<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useSpeckleManagement } from '@/composables/useSpeckleManagement'
import { useProjectSpeckleStore } from '@/store/projectSpeckle'

import GenericDialog from './GenericDialog.vue'
import { SpeckleModelSelect, SpeckleProjectSearch, useSpeckleStore } from '@haskoning/vue-speckle'
import SpeckleLoginRequiredDialog from './SpeckleLoginRequiredDialog.vue'
import { computed, watch } from 'vue'
import { useStore } from 'vuex'
import SpeckleVersionSelect from '@/components/speckle/SpeckleVersionSelect.vue'

const store = useStore()
const projectSpeckleStore = useProjectSpeckleStore()
const speckleStore = useSpeckleStore()

const { connectToSpeckleDialog, writeLoading: speckleLoading } = storeToRefs(projectSpeckleStore)
const { allVersions, currentSelection } = storeToRefs(speckleStore)
const currentProject = computed(() => store.state.project.currentProject)
const speckleManagement = useSpeckleManagement()

const setSelectedSpeckleModel = (id: string) => {
  store.dispatch('project/setSelectedSpeckleModel', id)
}
const updateCurrentProjectUserSpeckle = async () => {
  await store.dispatch('project/updateCurrentProjectUserSpeckle')
}

watch(
  () => currentSelection.value.model,
  async (value) => {
    if (value) {
      const modelId = value.id
      setSelectedSpeckleModel(modelId)
      await updateCurrentProjectUserSpeckle()
    }
  }
)

const closeDialog = () => {
  connectToSpeckleDialog.value = false
}

const versionId = computed({
  get: () => currentProject.value.currentprojectuser.selected_speckle_version_id,
  set: (val) => {
    setSelectedSpeckleVersion(val)
  }
})

const setSelectedSpeckleVersion = (id: string) => {
  store.dispatch('project/setSelectedSpeckleVersion', id)
}
</script>

<template>
  <GenericDialog
    v-if="speckleManagement.canUseSpeckle"
    v-model="connectToSpeckleDialog"
    @clicked-outside="closeDialog"
  >
    <template #title>Connect to Speckle</template>
    <template #default>
      <SpeckleProjectSearch
        @link="projectSpeckleStore.updateProjectSpeckle()"
      ></SpeckleProjectSearch>
      <SpeckleModelSelect variant="filled" class="mt-2"></SpeckleModelSelect>
      <SpeckleVersionSelect
        v-if="currentSelection?.model"
        :loading="speckleLoading"
        :items="allVersions"
        v-model="versionId"
        @update="updateCurrentProjectUserSpeckle"
        menu-icon="mdi-chevron-down"
        prepend-inner-icon="mdi-chart-line-variant"
        color="primary"
        class="mt-2"
      />
    </template>
    <template #actions>
      <v-btn @click="closeDialog"> Close </v-btn>
    </template>
  </GenericDialog>
  <SpeckleLoginRequiredDialog v-else v-model="connectToSpeckleDialog" @cancel="closeDialog" />
</template>

<style scoped></style>
